import {
  ICapabilitiesForUser,
  ICapability,
  IOrganizationService,
  ISelf,
  UserCapabilityName,
} from '../../types/types.generated';
import { IAuthUser, IPiAuthParams } from '../../types/authUser';

/**
 * Extract the info from the url sent over from SENet when a user logs in via ESSO
 */
export const parsePiNxtPostEssoQuery = (): IPiAuthParams => {
  const urlParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlParams) as unknown as IPiAuthParams;
};

export const hasCapability = (
  neededCapabilities: UserCapabilityName | UserCapabilityName[],
  currentCapabilities: UserCapabilityName[]
): boolean => {
  const capabilities = Array.isArray(neededCapabilities)
    ? neededCapabilities
    : [neededCapabilities];
  if (capabilities.length === 0) {
    return true;
  }

  return capabilities.some((cap) => currentCapabilities.includes(cap));
};

export const hasService = (
  neededService: string,
  currentServices: IOrganizationService[],
  currentCapabilities: ICapability[]
): boolean => {
  const currentService = currentServices.find(
    (service: IOrganizationService) => service.name === neededService
  );

  return !!currentService?.availableCapabilities.some((cap) =>
    currentCapabilities.some((currentCap) => currentCap.id === cap.id)
  );
};

/**
 * Builds the auth user onces all the data sources are finished returning data about the user.
 */
export const buildAuthUser = (
  selfData: ISelf,
  capabilitiesData: ICapabilitiesForUser,
  servicesData: IOrganizationService[],
  userAccessPolicies: string[]
): IAuthUser => {
  const {
    id,
    firstName,
    lastName,
    phone,
    email,
    pid,
    isInternalUser,
    registrationDuration,
  } = selfData;

  const capabilities = capabilitiesData.capabilities || [];

  const services: IOrganizationService[] = servicesData.filter(
    (service) =>
      service.availableCapabilities.filter(
        (capability) => !!capabilities?.find((cap) => capability.id === cap.id)
      ).length
  );

  return {
    id,
    firstName,
    lastName,
    phone,
    email,
    pid,
    isInternalUser,
    registrationDuration: registrationDuration || '',
    capabilities,
    services,
    accessPolicies: userAccessPolicies,
  };
};
